import classNames from 'clsx'
import { bool, func, node, oneOfType, shape, string } from 'prop-types'

import noop from 'shared/utils/noop'
import ErrorMessage from 'views/components/atoms/ErrorMessage'
import Flag from 'views/components/atoms/Flag'
import Input from 'views/components/atoms/Input'
import { ERROR_CLASSNAME } from 'views/consts'

import './InputCheckbox.scss'

const InputCheckbox = props => {
  const {
    onClick,
    errorMessage,
    children,
    checked,
    defaultChecked,
    nowLabel,
    labelSize,
    required,
    className,
    dataQaId,
    dataQaIdErr,
    ...rest
  } = props
  const isShippingOption = nowLabel
  const labelClassname = classNames(
    'm-InputCheckbox l-flex u-position--relative',
    {
      [ERROR_CLASSNAME]: errorMessage,
      'm-InputCheckbox--checkbox': props.type === 'checkbox',
      'm-InputCheckbox--radio': props.type === 'radio',
      'l-flex--wrap': !isShippingOption,
      'm-ShippingOption--checkbox': isShippingOption,
    },
    className
  )

  // Component should have either `value` or `defaultValue` set.
  // Default `null` is also value, so it cannot be passed as is.
  const checkedValues = { checked, defaultChecked }
  if (checked === null) {
    delete checkedValues.checked
  } else if (defaultChecked === null) {
    delete checkedValues.defaultChecked
  } else {
    throw new Error(
      'Component should not have both `value` and `defaultValue` set'
    )
  }

  const labelClasses = classNames(
    'm-InputCheckbox__label u-font-weight--normal u-no-margin',
    {
      'a-h4-tiny': labelSize === 'small-tiny',
      'a-h4': labelSize === 'small',
      'a-h3': !labelSize || labelSize === 'default',
      'u-no-wrap': isShippingOption,
      'm-ShippingOption__label': isShippingOption,
    }
  )

  const shouldRenderErrorMessage = errorMessage || props.type === 'checkbox'

  return (
    <label
      className={labelClassname}
      htmlFor={props.id}
      data-qa-id={dataQaId}
      data-clientside-hook={
        shouldRenderErrorMessage ? 'formControlContainer' : undefined
      }
    >
      <Input
        className="m-InputCheckbox__input"
        data-clientside-hook={
          shouldRenderErrorMessage ? 'formControlValidation' : undefined
        }
        onClick={onClick}
        required={required || undefined}
        {...rest}
        {...checkedValues}
      />
      {nowLabel && (
        <span className="m-InputCheckbox__flag u-margin-x-small--right">
          <Flag nowWidget smaller label="NOW!" />
        </span>
      )}
      <span className={labelClasses}>{children}</span>
      {shouldRenderErrorMessage && (
        <ErrorMessage text={errorMessage} dataQa={dataQaIdErr} />
      )}
    </label>
  )
}

InputCheckbox.propTypes = {
  children: node,
  checked: bool,
  onClick: func,
  defaultChecked: bool,
  value: string,
  id: string.isRequired,
  name: string.isRequired,
  disabled: bool,
  errorMessage: string,
  type: string,
  nowLabel: bool,
  required: bool,
  labelSize: string,
  className: oneOfType([string, shape({})]),
  dataQaId: string,
  dataQaIdErr: string,
}

InputCheckbox.defaultProps = {
  checked: null,
  defaultChecked: null,
  disabled: false,
  errorMessage: '',
  type: 'checkbox',
  value: 'off',
  nowLabel: false,
  required: false,
  labelSize: null,
  onClick: noop,
  className: '',
  dataQaId: '',
  dataQaIdErr: '',
}

export default InputCheckbox
